/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![ChatPlusIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABV0lEQVR4nN2UvUoDQRSFg6BoqcHnsRXC3HsTmNxjIKTbLpAU1vsAFio2ItaKPoZBfIn439qqsZDIbpYQsuvO/tk4cJtl5nx3zrmztdq/Xju93roR7BHjmlifiPXTML6M4NEwLqnZhud5q4XEjaBtBC8kmKZVuIfQzCzs+/4KMU5cwrQMYhwFZ92dsx7nFad56aHDFm0VF0dkmbYSxa21a4b1tSyABM+BVgzArJ0KxKdBMavGAMR6VRWAWC+SAPdVAQxjHAcIJpXdQPCeMJ74KCg2IcJQpFtvNDqbhtE3rGdJgHFBOwaps182ZJFuPWxQcEuso9R/T/7u9W0hw/Dbr4DgcZDgIYvnhjGw1m4tDUk6YLZJ950AwjD5rAOwa+12lqBt1HnoufvBzTKx1m4Q4y5PqMQ6cmYkuIkC1tMcY9nPbREJDgzrd0bIeaEMyq6/B7CO5p4vrB/jHX28LgwP0QAAAABJRU5ErkJggg==)
 */
export const ChatPlusIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        d="M19 14a1 1 0 0 1 1 1v3h3a1 1 0 1 1 0 2h-3v3a1 1 0 1 1-2 0v-3h-3a1 1 0 1 1 0-2h3v-3a1 1 0 0 1 1-1Z"
        fill={typeof color === 'string' ? color : color.css}
        className={colorClass}
      />
      <path
        d="M20.76 12.57c.4.3 1.23.13 1.24-.37V12a10 10 0 1 0-18.44 5.36c.12.19.1.44-.04.61l-2.07 2.37A1 1 0 0 0 2.2 22h10c.5-.01.67-.84.37-1.24A3 3 0 0 1 15 16h.5a.5.5 0 0 0 .5-.5V15a3 3 0 0 1 4.76-2.43Z"
        fill={typeof color === 'string' ? color : color.css}
        className={colorClass}
      />
    </svg>
  );
};
